import { style } from "typestyle";
import { White } from "@traceair/tds";
import * as React from "react";

interface ILogoutIconProps {
  onClick: () => void;
}
const LogoutIcon = ({ onClick }: ILogoutIconProps): JSX.Element => (
  <svg
    width="18px"
    height="18px"
    viewBox="0 0 18 18"
    onClick={onClick}
    className={style({ cursor: "pointer" })}
  >
    <g
      id="Backoffice"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="BO---Companies" transform="translate(-834.000000, -23.000000)">
        <g id="Header">
          <g id="User" transform="translate(831.000000, 20.000000)">
            <g id="ic/exit-W">
              <polygon id="Shape" points="0 0 24 0 24 24 0 24" />
              <g
                id="Group-2"
                strokeWidth="1"
                fillRule="evenodd"
                transform="translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, -12.000000) translate(3.000000, 3.000000)"
                fill={White}
              >
                <polygon
                  id="Shape"
                  fillRule="nonzero"
                  points="11.09 12.59 12.5 14 17.5 9 12.5 4 11.09 5.41 13.67 8 4 8 4 10 13.67 10"
                />
                <path
                  d="M6,0 L2,0 C0.9,0 0,0.9 0,2 L0,16 C0,17.1 0.9,18 2,18 L6,18 L6,16 L2,16 L2,2 L6,2 L6,-1.66533454e-16 Z"
                  id="Combined-Shape"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default LogoutIcon;
